import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  TextField,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import api from "../../../services/api";

const SupplyItemSelector = ({ selectedItem, onSelect, options }) => {
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);

  const createCustomItem = (name) => ({
    _id: `custom-${Date.now()}`,
    label: name,
    name,
    type: "custom",
    unit: "",
    store: null,
  });

  const filteredOptions = inputValue
    ? options.filter((opt) =>
        opt.label.toLowerCase().includes(inputValue.toLowerCase())
      )
    : options;

  const showCustomOption =
    inputValue &&
    !filteredOptions.some(
      (opt) => opt.label.toLowerCase() === inputValue.toLowerCase()
    );

  const displayedOptions = [
    ...filteredOptions,
    ...(showCustomOption ? [createCustomItem(inputValue)] : []),
  ];

  return (
    <Autocomplete
      options={displayedOptions}
      value={selectedItem}
      onChange={(e, value) => onSelect(value)}
      inputValue={inputValue}
      onInputChange={(e, value) => {
        const trimmed = value.trimStart(); // let trailing space be typed for UX
        const cleaned = trimmed.replace(/[^a-zA-Z\s()\-']/g, ""); // allow spaces
        const capitalized = cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
        setInputValue(capitalized);
      }}
      groupBy={(option) => option.group || ""}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(opt, val) => opt._id === val._id}
      loading={loading}
      renderOption={(props, option) => {
        const { key, ...rest } = props;

        return (
          <Box
            key={key}
            component="li"
            {...rest}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            gap={1}
            pr={1}>
            <Typography variant="body2" noWrap sx={{ flexGrow: 1 }}>
              {option.label}
            </Typography>
          </Box>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Select Item"
          size="small"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading && <CircularProgress size={16} />}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default SupplyItemSelector;
